module.exports = __webpack_public_path__ + "img/noData.bdf98b11.png";